import { STORAGE_AUTHOR_HASH, STORAGE_TOKEN, STORAGE_USER_ID, STORAGE_USER_PREF } from "../../constants/localstorage";
import { logIn } from "../../libs/auth";
import { setStorage } from "../../libs/storage";
import { PushLoginTokenResponse } from "../../proto/PushLoginToken_pb";
import BaseHandler from "../BaseHandler";
import MultiAccount from "../../libs/multiAccount";
import { AccountDetector } from "../../constants/globals";
import { memoryHistory } from "../../index";
import { ROUTE_MESSENGER } from "../../constants/routes";

export default class HandlePushLoginTokenResponse extends BaseHandler<PushLoginTokenResponse> {
  handle() {
    const pushLoginTokenResponse = this.response.toObject();
    setStorage(STORAGE_USER_ID, pushLoginTokenResponse.userId);
    setStorage(STORAGE_AUTHOR_HASH, pushLoginTokenResponse.authorHash);
    setStorage(STORAGE_TOKEN, pushLoginTokenResponse.token);
    if (MultiAccount.prefixDetector(AccountDetector.NEW) === 1) {
      setStorage(STORAGE_USER_PREF, MultiAccount.prefixDetector(AccountDetector.NEW), false, false);
    }
    logIn();
    memoryHistory.push(ROUTE_MESSENGER);
  }
}
